import { useState } from 'react';

const reviews = [
  {
    name: 'Michael R.',
    vehicle: 'Mercedes-Benz S-Class Owner',
    rating: 5,
    text: 'They return your car better than factory condition. I\'ve taken my S-Class here twice and both times I was absolutely blown away. The paint matching is on another level — you literally cannot tell where the repair was made.',
    image: 'https://public.readdy.ai/ai/img_res/0e290afe98045e5c242dd571b938cb0b.jpg',
  },
  {
    name: 'Sophia L.',
    vehicle: 'Porsche 911 Owner',
    rating: 5,
    text: 'Flawless paint work and incredible service. My Porsche 911 was rear-ended and I was devastated. The Royal Collision Centre restored it to absolute perfection. The team is professional, communicative, and genuinely passionate about their craft.',
    image: 'https://readdy.ai/api/search-image?query=silver-porsche-911-sports-car-parked-on-dark-background-studio-lighting-premium-automotive-photography-glossy-metallic-paint&width=400&height=400&seq=rev002&orientation=squarish',
  },
  {
    name: 'James T.',
    vehicle: 'BMW 7 Series Owner',
    rating: 5,
    text: 'The only shop I trust with my cars. I\'ve been a client for years and have sent every vehicle in my collection here. Their attention to detail is unmatched — they treat every car as if it were their own.',
    image: 'https://readdy.ai/api/search-image?query=dark-navy-bmw-7-series-luxury-sedan-parked-on-clean-dark-background-studio-lighting-premium-automotive-photography-glossy-paint&width=400&height=400&seq=rev003&orientation=squarish',
  },
  {
    name: 'Elena M.',
    vehicle: 'Range Rover Owner',
    rating: 5,
    text: 'Very professional and detail-oriented. From the moment I walked in, I knew this was a different kind of shop. They handled my insurance claim seamlessly and delivered my Range Rover looking better than the day I bought it.',
    image: 'https://readdy.ai/api/search-image?query=white-range-rover-luxury-suv-parked-on-clean-dark-background-studio-lighting-premium-automotive-photography-glossy-paint-finish&width=400&height=400&seq=rev004&orientation=squarish',
  },
];

export default function Reviews() {
  const [active, setActive] = useState(0);
  const current = reviews[active];

  return (
    <section id="reviews" className="bg-black py-28 md:py-36 w-full">
      <div className="max-w-[1600px] mx-auto px-6 md:px-16">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-yellow-600 text-xs tracking-[0.4em] uppercase font-light">Client Testimonials</span>
          <h2 className="font-serif text-4xl md:text-5xl text-white mt-4 mb-5">
            What Our Clients <span className="text-yellow-400 italic">Say</span>
          </h2>
          <div className="flex items-center justify-center gap-4">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-yellow-600"></div>
            <div className="w-2 h-2 rounded-full bg-yellow-600"></div>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-yellow-600"></div>
          </div>
        </div>

        {/* Review card */}
        <div className="flex flex-col lg:flex-row rounded-2xl overflow-hidden border border-yellow-700/20 bg-[#0d0d0d] min-h-[400px]">
          {/* Left image */}
          <div className="lg:w-2/5 relative overflow-hidden">
            <img
              src={current.image}
              alt={current.vehicle}
              className="w-full h-64 lg:h-full object-cover object-top transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0d0d0d] hidden lg:block"></div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent lg:hidden"></div>
          </div>

          {/* Right content */}
          <div className="lg:w-3/5 p-6 md:p-16 flex flex-col justify-between">
            {/* Quote */}
            <div>
              <div className="text-yellow-500/40 font-serif text-6xl md:text-8xl leading-none mb-2 md:mb-4">&ldquo;</div>
              <p className="text-white/80 text-sm md:text-xl leading-relaxed font-light italic -mt-5 md:-mt-8">
                {current.text}
              </p>
            </div>

            {/* Attribution */}
            <div className="mt-10">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: current.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-sm"></i>
                ))}
              </div>
              <div className="text-white font-serif text-xl">{current.name}</div>
              <div className="text-yellow-600/70 text-xs tracking-widest uppercase mt-1">{current.vehicle}</div>

              {/* Navigation */}
              <div className="flex items-center gap-4 mt-8">
                <button
                  onClick={() => setActive((active - 1 + reviews.length) % reviews.length)}
                  className="w-12 h-12 flex items-center justify-center rounded-full border border-yellow-700/40 text-yellow-600 hover:border-yellow-500 hover:text-yellow-400 transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button
                  onClick={() => setActive((active + 1) % reviews.length)}
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-yellow-600 text-black hover:bg-yellow-500 transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
                <div className="flex gap-2 ml-2">
                  {reviews.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setActive(i)}
                      className={`h-1 rounded-full transition-all duration-300 cursor-pointer ${i === active ? 'w-8 bg-yellow-500' : 'w-2 bg-yellow-700/40'}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Google rating badge */}
        <div className="flex justify-center mt-12">
          <div className="flex items-center gap-4 px-8 py-4 rounded-full border border-yellow-700/30 bg-[#0d0d0d]">
            <i className="ri-google-fill text-yellow-500 text-xl"></i>
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className={`ri-star-fill text-sm ${i < 4 ? 'text-yellow-500' : 'text-yellow-500/60'}`}></i>
              ))}
            </div>
            <span className="text-white font-serif text-lg">4.7</span>
            <span className="text-white/40 text-xs tracking-widest uppercase">Google Rating</span>
          </div>
        </div>
      </div>
    </section>
  );
}
